import { BaseRequest, PagingRequest } from 'Services/base';
import { getQueryParamsForListAPI, ListItems } from 'Services/api';
import { ICommission, ICommissionRecipient, IEstimateCommissions, IEstimateCommissionsRequest } from './interfaces';

export class ListCommissionsRequest extends BaseRequest<ListItems<ICommission>> {
  constructor(
    pageParameters: PagingRequest,
    searchValue?: string,
    expand?: string[],
  ) {
    const queryParams = getQueryParamsForListAPI( pageParameters, searchValue, 'search' );

    if ( expand && expand.length > 0 ) {
      const expandPars = expand.map( ( item ) => `${encodeURIComponent( item )}` ).join( ',' );
      queryParams.set( 'expand', expandPars );
    }

    super( {
      method: 'GET',
      url: '/commissionservice/v1/commissions',
      responseType: 'json',
      params: queryParams,
    } );
  }
}

export class ListCommissionRecipientsRequest extends BaseRequest<ListItems<ICommissionRecipient>> {
  constructor(
    pageParameters: PagingRequest,
    searchValue?: string,
    expand?: string[],
  ) {
    const queryParams = getQueryParamsForListAPI( pageParameters, searchValue, 'search' );

    if ( expand && expand.length > 0 ) {
      const expandPars = expand.map( ( item ) => `${encodeURIComponent( item )}` ).join( ',' );
      queryParams.set( 'expand', expandPars );
    }

    super( {
      method: 'GET',
      url: '/commissionservice/v1/commission-recipients',
      responseType: 'json',
      params: queryParams,
    } );
  }
}

export class EstimateCommissionRequest extends BaseRequest<IEstimateCommissions> {
  constructor(
    data: IEstimateCommissionsRequest,
  ) {
    super( {
      method: 'POST',
      url: '/commissionservice/v1/commissions/estimate',
      data,
      responseType: 'json',
    } );
  }
}
